module.exports = __webpack_public_path__ + "static/img/visualization_lollipop.c981d33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/visualization_lollipop.png
// module id = XtG1
// module chunks = 94